import React, { useState, useEffect} from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Tabs } from "components";

import "./style.scss";

import FindMentees from "./FindMentees";
import MentorProfile from "./MentorProfile";
import RequestFromMentees from "./RequestFromMentees";
import YourCurrentMentees from "./YourCurrentMentees";
import PopupPremiumUser from "components/Popups/PopupPremiumUser";

const Mentor = ({
  userProfile,
  mentorProfile,
  menteeProfile,
  createMentor,
  updateMentor,
  getOneMentor,
  getOneMentee,
  getUser,
  mentorListFind,
  menteeListFind,
  createRequest,
  updateRequest,
  requestListMentor,
  requestListMentee,
  notificationsCount,
  notifications,
  markNotificationToRead,
  getNotifications,
  subCurrentTab
}) => {
  const [currentTab, setCurrentTab] = useState("0");
  const [showMessage, setShowMessage] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(()=>{
    if(subCurrentTab !== null && location.search === '?key=mentor-notification'){
      setCurrentTab(subCurrentTab)

      setTimeout(()=>{
        const newSearch = location.search.replace('?key=mentor-notification', '');
        history.replace({ search: newSearch });
      },1000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[subCurrentTab,location])

  const TabData = [
    {
      title: "Mentor Profile",
      key: 1,
      content: () => (
        <MentorProfile
          userProfile={userProfile}
          mentorProfile={mentorProfile}
          menteeProfile={menteeProfile}
          createMentor={createMentor}
          updateMentor={updateMentor}
          getOneMentor={getOneMentor}
          getUser={getUser}
        />
      ),
    },
    mentorProfile?.status === "active" && {
      title: (
        <span
          style={{ padding: "17px 0" }}
          onClick={() =>
            mentorProfile?.topics?.length < 1 ? setShowMessage(true) : null
          }
        >
          Find Mentees
        </span>
      ),
      key: 2,
      content: () => (
        <FindMentees
          userProfile={userProfile}
          mentorProfile={mentorProfile}
          menteeProfile={menteeProfile}
          getOneMentor={getOneMentor}
          getOneMentee={getOneMentee}
          getUser={getUser}
          mentorListFind={mentorListFind}
          menteeListFind={menteeListFind}
          createRequest={createRequest}
          updateRequest={updateRequest}
        />
      ),
      disabled: mentorProfile?.topics?.length < 1,
    },
    mentorProfile?.status === "active" && {
      title: (
        <span
          style={{ padding: "17px 0" }}
          onClick={() =>
            mentorProfile?.topics?.length < 1 ? setShowMessage(true) : null
          }
        >
          Request from Mentees
        </span>
      ),
      notificationsCount: notificationsCount,
      key: 3,
      content: () => (
        <RequestFromMentees
          mentorProfile={mentorProfile}
          menteeProfile={menteeProfile}
          updateRequest={updateRequest}
          userProfile={userProfile}
          getOneMentor={getOneMentor}
          requestListMentor={requestListMentor}
          requestListMentee={requestListMentee}
          getUser={getUser}
          notifications={notifications}
          markNotificationToRead={markNotificationToRead}
          getNotifications={getNotifications}
        />
      ),
      disabled: mentorProfile?.topics?.length < 1,
    },
    mentorProfile?.status === "active" && {
      title: (
        <span
          style={{ padding: "17px 0" }}
          onClick={() =>
            mentorProfile?.topics?.length < 1 ? setShowMessage(true) : null
          }
        >
          Your Current Mentees
        </span>
      ),
      key: 4,
      content: () => (
        <YourCurrentMentees
          mentorProfile={mentorProfile}
          menteeProfile={menteeProfile}
          updateRequest={updateRequest}
          userProfile={userProfile}
          getOneMentor={getOneMentor}
          requestListMentor={requestListMentor}
          requestListMentee={requestListMentee}
          getUser={getUser}
        />
      ),
      disabled: mentorProfile?.topics?.length < 1,
    },
  ].filter(Boolean);

  return (
    <>
      <Tabs data={TabData} current={currentTab} onChange={setCurrentTab} />
      {showMessage && (
        <PopupPremiumUser
          onclick={() => setShowMessage(false)}
          text="You must complete your profile as Mentor"
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Mentor);
